(function () {
  'use strict';

  /* ============================================================
     CARRIER DATA
     Portrait URLs / posters: landscape fallback used when blank.
  ============================================================ */
  function getVideoUrl(clip) {
    var isMobile = window.innerWidth <= 700;
    if (isMobile && clip.portrait_url) return clip.portrait_url;
    if (!isMobile && clip.url) return clip.url;
    return clip.portrait_url || clip.url;
  }

  var CARRIERS = {
    sprout: {
      label: 'Sprout newborn carrier',
      clips: [
        { title: 'Sprout tutorial',                 url: 'https://cdn.shopify.com/videos/c/o/v/2cc8f064c7dc446d8a13f1d36cf0369e.mp4', portrait_url: 'https://cdn.shopify.com/videos/c/o/v/6e07c8b986e7485b8ec4e948f6d71dcb.mp4', duration: '1:42', cc: true },
        { title: 'Preventing neck creep',           url: 'https://cdn.shopify.com/videos/c/o/v/5ec34b4f76d7404385bfc75c750338e8.mp4', portrait_url: 'https://cdn.shopify.com/videos/c/o/v/a24aaed39ac1445bbfc13a4605cb6601.mp4', duration: '0:09', cc: true },
        { title: 'Taking baby out safely',          url: 'https://cdn.shopify.com/videos/c/o/v/5c28cb403bef4ccfb89436926ce475a2.mp4', portrait_url: 'https://cdn.shopify.com/videos/c/o/v/37c691be17b74af3bc73886c86d2500d.mp4', duration: '0:18', cc: true },
        { title: 'Safety check before you go',      url: 'https://cdn.shopify.com/videos/c/o/v/dd8aa59dbab9417cb380f63b37dc99f2.mp4', portrait_url: 'https://cdn.shopify.com/videos/c/o/v/2a2e57ad9e5d4c04b712c2a2500265e5.mp4', duration: '0:13', cc: true },
        { title: 'Using the safety loop',           url: 'https://cdn.shopify.com/videos/c/o/v/6778718bed71400495168a765cd4aa12.mp4', portrait_url: 'https://cdn.shopify.com/videos/c/o/v/12dfc7b1c454472bb4bfe71186367e0e.mp4', duration: '0:06', cc: true },
        { title: 'Rolling excess webbing',          url: 'https://cdn.shopify.com/videos/c/o/v/b63602c054f749fb84c9cc06509c6113.mp4', portrait_url: 'https://cdn.shopify.com/videos/c/o/v/d4d7075f0393457ba8ab07e171f2a0b6.mp4', duration: '0:09', cc: true },
        { title: 'Feeding your baby in the Sprout', url: 'https://cdn.shopify.com/videos/c/o/v/78b0b2d31b034552b998b964656f1af2.mp4', portrait_url: 'https://cdn.shopify.com/videos/c/o/v/a3207d1acb794197b5e2dfd748d547e5.mp4', duration: '0:46', cc: true }
      ]
    },
    lark: {
      label: 'Lark baby & kid carrier',
      clips: [
        { title: 'Putting it on',                             url: 'https://cdn.shopify.com/videos/c/o/v/885ac866a167406f8490e10b57086ec9.mp4', portrait_url: 'https://cdn.shopify.com/videos/c/o/v/10d894b03f954d52a3c9e33b0355c62e.mp4', duration: '0:25', cc: true },
        { title: 'Putting your baby in — front carry',        url: 'https://cdn.shopify.com/videos/c/o/v/874575a19d5b4bacba2e3dead717b5ff.mp4', portrait_url: 'https://cdn.shopify.com/videos/c/o/v/3bf9ba42909d41ee96949abdd3233cf7.mp4', duration: '1:17', cc: false },
        { title: 'Panel too wide',                            url: 'https://cdn.shopify.com/videos/c/o/v/36fe390cc53748308383fdfd607f522d.mp4', portrait_url: 'https://cdn.shopify.com/videos/c/o/v/9135db52dc494f0b8988f203bba8cc33.mp4', duration: '0:17', cc: true },
        { title: 'Panel too narrow',                          url: 'https://cdn.shopify.com/videos/c/o/v/b0e6ff30a89d40a8a4d372652f12ac66.mp4', portrait_url: 'https://cdn.shopify.com/videos/c/o/v/0c2fe04625ad40ed8029a5abd03f0889.mp4', duration: '0:12', cc: true },
        { title: 'Neck creep',                                url: 'https://cdn.shopify.com/videos/c/o/v/96d280570cef4f94a6b979e144343638.mp4', portrait_url: 'https://cdn.shopify.com/videos/c/o/v/5c72da7c32db4a8cae50157ca5ca4635.mp4', duration: '0:33', cc: true },
        { title: 'In depth small baby tutorial',              url: '', portrait_url: 'https://cdn.shopify.com/videos/c/o/v/d51530914e1a46d7bd61d0e57cd55db2.mp4', duration: '4:23', cc: true },
        { title: 'Nursing in the Lark',                       url: 'https://cdn.shopify.com/videos/c/o/v/026f2142d3fb407c8debbf5a22399095.mp4', portrait_url: 'https://cdn.shopify.com/videos/c/o/v/b3a2801ef54f4347a1119c28fb7b0de3.mp4', duration: '0:42', cc: true },
        { title: 'Bottle feeding in the Lark',                url: 'https://cdn.shopify.com/videos/c/o/v/74844f3c8e764618b6aa18962c52922f.mp4', portrait_url: 'https://cdn.shopify.com/videos/c/o/v/1b845249d23b4e319b872fa2f89f1a7d.mp4', duration: '0:39', cc: true },
        { title: 'Front-to-back',                             url: 'https://cdn.shopify.com/videos/c/o/v/71ea56d9f4714e00bd374d7dc17bc215.mp4', portrait_url: 'https://cdn.shopify.com/videos/c/o/v/43a69ad31a614f8f94f953bd9316df36.mp4', duration: '1:24', cc: true },
        { title: 'Back carry',                                url: 'https://cdn.shopify.com/videos/c/o/v/5767dd3f08534fe6a80561dfa149f06b.mp4', portrait_url: 'https://cdn.shopify.com/videos/c/o/v/b96a2218aace40d8847969f1fc886d0a.mp4', duration: '1:29', cc: true },
        { title: 'Back carry adjustments',                    url: 'https://cdn.shopify.com/videos/c/o/v/07a5c21e28c34af18778f4a832521a5e.mp4', portrait_url: 'https://cdn.shopify.com/videos/c/o/v/16bfc99fdca5457b84422751dacb6fbb.mp4', duration: '0:22', cc: true },
        { title: 'Chest strap adjustment',                    url: 'https://cdn.shopify.com/videos/c/o/v/c3d610e039224790b6750b081c6000b7.mp4', portrait_url: 'https://cdn.shopify.com/videos/c/o/v/934acac3c817470b8b2a01c49a30d77b.mp4', duration: '0:04', cc: true },
        { title: 'Narrowing straps',                          url: 'https://cdn.shopify.com/videos/c/o/v/953bc8e0907d458fb3a890d8f059a85f.mp4', portrait_url: 'https://cdn.shopify.com/videos/c/o/v/ef04bb24871d42d8aca59f2596b759f2.mp4', duration: '0:20', cc: true },
        { title: 'Remove carrier back',                       url: 'https://cdn.shopify.com/videos/c/o/v/c91abf8c5df7478896dc2f42688ae615.mp4', portrait_url: 'https://cdn.shopify.com/videos/c/o/v/39805f5528104e93b52d47ead8429eb7.mp4', duration: '0:34', cc: true }
      ]
    },
    ringsling: {
      label: 'Ring sling',
      clips: [
        { title: 'Threading on your body',          url: 'https://cdn.shopify.com/videos/c/o/v/237574bb8d564589bdeadbc0d28dba36.mp4', portrait_url: 'https://cdn.shopify.com/videos/c/o/v/237574bb8d564589bdeadbc0d28dba36.mp4', duration: '2:06', cc: true },
        { title: 'Placing baby in',                 url: 'https://cdn.shopify.com/videos/c/o/v/bcdb2c2af6ee4c829c48ff42565f900a.mp4', portrait_url: 'https://cdn.shopify.com/videos/c/o/v/30fa99b2cd034ee39382315bfe375e50.mp4', duration: '1:16', cc: true },
        { title: 'Nursing',                         url: 'https://cdn.shopify.com/videos/c/o/v/906f99f42584452c83010be143ed61f5.mp4', portrait_url: 'https://cdn.shopify.com/videos/c/o/v/e56f60a8d76d41b08461ce2318f93864.mp4', duration: '0:46', cc: true },
        { title: 'Bottle feeding',                  url: 'https://cdn.shopify.com/videos/c/o/v/13d07ea784684027897e0a6afd1647d5.mp4', portrait_url: 'https://cdn.shopify.com/videos/c/o/v/af7991899e2949e686d504278679198a.mp4', duration: '0:40', cc: true },
        { title: 'Front carry',                     url: 'https://cdn.shopify.com/videos/c/o/v/31bb1ed0d4384c1480e0f8e3638e6ef0.mp4', portrait_url: 'https://cdn.shopify.com/videos/c/o/v/7ce257366bc445119f9342c17287c499.mp4', duration: '2:12', cc: true }
      ]
    },
    babywrap: {
      label: 'Baby wrap',
      clips: [
        { title: 'Getting it on and putting baby in', url: 'https://cdn.shopify.com/videos/c/vp/c6f2fb6995224c5c8b00f4a95556afbc/c6f2fb6995224c5c8b00f4a95556afbc.SD-480p-0.9Mbps-88781099.mp4', portrait_url: 'https://cdn.shopify.com/videos/c/vp/04f9a6811f8147a89bed273ebd6ff594/04f9a6811f8147a89bed273ebd6ff594.SD-480p-1.2Mbps-88781108.mp4', duration: '3:41', cc: true },
        { title: 'Fix slack in your wrap',            url: 'https://cdn.shopify.com/videos/c/vp/74f03a0b73564ea78ee991ff545de884/74f03a0b73564ea78ee991ff545de884.SD-480p-0.9Mbps-88781100.mp4', portrait_url: 'https://cdn.shopify.com/videos/c/vp/fa6d654e032f4ea5a677be2cf0de024e/fa6d654e032f4ea5a677be2cf0de024e.SD-480p-1.2Mbps-88781109.mp4', duration: '1:19', cc: true },
        { title: 'Checking the fit',                  url: 'https://cdn.shopify.com/videos/c/vp/75edeed974f54ac881420c0b5222f686/75edeed974f54ac881420c0b5222f686.SD-480p-0.9Mbps-88781101.mp4', portrait_url: 'https://cdn.shopify.com/videos/c/vp/cfe3a7d53f754de1a24b40247e5e2e7a/cfe3a7d53f754de1a24b40247e5e2e7a.SD-480p-1.0Mbps-88781110.mp4', duration: '0:29', cc: true },
        { title: 'Shoulder flip',                     url: 'https://cdn.shopify.com/videos/c/vp/72911a6d405742c89732b626a345e082/72911a6d405742c89732b626a345e082.SD-480p-0.9Mbps-88781103.mp4', portrait_url: 'https://cdn.shopify.com/videos/c/vp/03dbb404aa944875937fdf6aa81e4e86/03dbb404aa944875937fdf6aa81e4e86.SD-480p-1.2Mbps-88781112.mp4', duration: '0:15', cc: true },
        { title: 'Bending down in the wrap',          url: 'https://cdn.shopify.com/videos/c/vp/73eeb012f9164ba6949646d4ab947a0f/73eeb012f9164ba6949646d4ab947a0f.SD-480p-0.9Mbps-88781102.mp4', portrait_url: 'https://cdn.shopify.com/videos/c/vp/b68d1119de234b4fbaf0a1dfe6b51361/b68d1119de234b4fbaf0a1dfe6b51361.SD-480p-1.0Mbps-88781111.mp4', duration: '0:15', cc: true },
      ]
    },
    mehdai: {
  label: 'Meh dai',
  clips: [
    { title: 'Narrowing the panel for a newborn',   url: 'https://cdn.shopify.com/videos/c/vp/f187874e2c5b4c25a5584790a2f59416/f187874e2c5b4c25a5584790a2f59416.SD-480p-1.0Mbps-88888646.mp4', portrait_url: 'https://cdn.shopify.com/videos/c/vp/280cfaeb16e5454ca200cb11e9acea53/280cfaeb16e5454ca200cb11e9acea53.SD-480p-1.2Mbps-88888779.mp4', duration: '0:36', cc: true },
    { title: 'Front carry',                         url: 'https://cdn.shopify.com/videos/c/vp/a59e3c84827e4cd1af5b78572abc6a30/a59e3c84827e4cd1af5b78572abc6a30.SD-480p-1.0Mbps-88888649.mp4', portrait_url: 'https://cdn.shopify.com/videos/c/vp/a0a472de72ab4079bec092b8483f95e7/a0a472de72ab4079bec092b8483f95e7.SD-480p-1.2Mbps-88888782.mp4', duration: '2:18', cc: true },
    { title: 'Fit check and adjustments',           url: 'https://cdn.shopify.com/videos/c/vp/43f7ce2073944e3ea98c2451198a1cf9/43f7ce2073944e3ea98c2451198a1cf9.SD-480p-1.0Mbps-88888650.mp4', portrait_url: 'https://cdn.shopify.com/videos/c/vp/5280eedb882e4c19b1135e88050b519a/5280eedb882e4c19b1135e88050b519a.SD-480p-1.2Mbps-88888783.mp4', duration: '0:27', cc: true },
    { title: 'Getting baby out',                    url: 'https://cdn.shopify.com/videos/c/vp/12af4fc281324dd4874a577f85b2396b/12af4fc281324dd4874a577f85b2396b.SD-480p-1.0Mbps-88888647.mp4', portrait_url: 'https://cdn.shopify.com/videos/c/vp/14b65be1a7ce4a78a0a2bd4d323aa878/14b65be1a7ce4a78a0a2bd4d323aa878.SD-480p-1.2Mbps-88888780.mp4', duration: '0:30', cc: true },
    { title: 'Back carry',                          url: 'https://cdn.shopify.com/videos/c/vp/1a8408f45da046779125bdd68ed44426/1a8408f45da046779125bdd68ed44426.SD-480p-1.0Mbps-88888651.mp4', portrait_url: 'https://cdn.shopify.com/videos/c/vp/0baab6d85ba34848840df3caca4ceb8f/0baab6d85ba34848840df3caca4ceb8f.SD-480p-1.2Mbps-88888784.mp4', duration: '1:59', cc: true },
    { title: 'Back carry fit check',                url: 'https://cdn.shopify.com/videos/c/vp/0a6c16942b0e48019773083f0791ec63/0a6c16942b0e48019773083f0791ec63.SD-480p-1.0Mbps-88888652.mp4', portrait_url: 'https://cdn.shopify.com/videos/c/vp/f3cdb01d01144da18c4d21bcd9a49a5e/f3cdb01d01144da18c4d21bcd9a49a5e.SD-480p-1.2Mbps-88888785.mp4', duration: '0:10', cc: true },
    { title: 'Back carry finish knotless tied tibetan', url: 'https://cdn.shopify.com/videos/c/vp/880b2b4a651d4896b20e713ea43633d2/880b2b4a651d4896b20e713ea43633d2.SD-480p-1.0Mbps-88888653.mp4', portrait_url: 'https://cdn.shopify.com/videos/c/vp/3b78d28b7c4a4f038e5f59ea4e249e62/3b78d28b7c4a4f038e5f59ea4e249e62.SD-480p-1.2Mbps-88888786.mp4', duration: '0:55', cc: true },
    { title: 'Getting baby out of a back carry',    url: 'https://cdn.shopify.com/videos/c/vp/d9397f6939ff4603b176ed6e050ce1b7/d9397f6939ff4603b176ed6e050ce1b7.SD-480p-1.0Mbps-88888648.mp4', portrait_url: 'https://cdn.shopify.com/videos/c/vp/452983abf0dc43f5a29acd1f33b125ca/452983abf0dc43f5a29acd1f33b125ca.SD-480p-1.2Mbps-88888781.mp4', duration: '0:45', cc: true },
  ]
},

  };

  /* ============================================================
     REGISTRY + STATE
     panels[bid] = { carrierId }
     state[bid]  = { currentIndex, mode }
  ============================================================ */
  var panels = {};
  var state  = {};

  /* ============================================================
     HELPERS
  ============================================================ */
  function el(id) { return document.getElementById(id); }

  function getClips(bid) { return CARRIERS[panels[bid].carrierId].clips; }

  function getPoster(bid) {
    var img = el('hpctv-poster-' + bid);
    return img ? img.getAttribute('src') : '';
  }

  function totalDuration(clips) {
    var mins = 0;
    clips.forEach(function (c) {
      var parts = c.duration.split(':');
      mins += parseInt(parts[0], 10) + parseInt(parts[1], 10) / 60;
    });
    return '~' + Math.round(mins) + ' min total';
  }

  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  function setVideoSource(videoEl, url, poster) {
    videoEl.src = url;
    if (poster) videoEl.poster = poster;
    videoEl.load();
  }

  /* ============================================================
     BUILD PLAYLIST (full tutorial view)
  ============================================================ */
  function buildPlaylist(bid) {
    var clips     = getClips(bid);
    var poster    = getPoster(bid);
    var container = el('hpctv-pitems-' + bid);
    var label     = el('hpctv-plabel-' + bid);
    if (!container || !label) return;

    label.textContent = clips.length + ' clips · ' + totalDuration(clips);
    container.innerHTML = '';

    clips.forEach(function (clip, i) {
      var item = document.createElement('div');
      item.className = 'hpctv__pl-item' + (i === 0 ? ' is-active' : '');
      item.dataset.index = i;
      item.dataset.bid = bid;

      item.innerHTML =
        '<div class="hpctv__pl-thumb">' +
          '<img src="' + poster + '" alt="" loading="lazy">' +
          '<div class="hpctv__pl-mask"></div>' +
          '<div class="hpctv__pl-num">' + (i + 1) + '</div>' +
        '</div>' +
        '<div class="hpctv__pl-title-wrap">' +
          '<div class="hpctv__pl-title">' + clip.title + '</div>' +
          '<div class="hpctv__pl-dot' + (i === 0 ? ' hpctv__pl-dot--now' : '') + '"></div>' +
        '</div>' +
        '<div class="hpctv__pl-dur">' + clip.duration + '</div>';

      item.addEventListener('click', function () {
        playClipFull(bid, parseInt(this.dataset.index, 10));
      });

      container.appendChild(item);
    });
  }

  /* ============================================================
     BUILD CLIPS GRID
  ============================================================ */
  function buildClipsGrid(bid) {
    var clips  = getClips(bid);
    var poster = getPoster(bid);
    var grid   = el('hpctv-cgrid-' + bid);
    if (!grid) return;
    grid.innerHTML = '';

    clips.forEach(function (clip, i) {
      var card = document.createElement('div');
      card.className = 'hpctv__clip-card';
      card.dataset.index = i;
      card.dataset.bid = bid;

      card.innerHTML =
        '<div class="hpctv__clip-thumb">' +
          '<img src="' + poster + '" alt="" loading="lazy">' +
          '<div class="hpctv__clip-mask"></div>' +
          '<div class="hpctv__clip-play"><div class="hpctv__clip-play-tri"></div></div>' +
          '<div class="hpctv__clip-title-tag">' +
            '<span class="hpctv__clip-num-label">' + pad(i + 1) + '</span>' +
            '<span class="hpctv__clip-name">' + clip.title + '</span>' +
          '</div>' +
        '</div>' +
        '<div class="hpctv__clip-info"><div class="hpctv__clip-dur">' + clip.duration + '</div></div>';

      card.addEventListener('click', function () {
        playClipSingle(bid, parseInt(this.dataset.index, 10));
      });

      grid.appendChild(card);
    });
  }

  /* ============================================================
     PLAYER INIT
  ============================================================ */
  function initPlayer(bid) {
    updatePlayerUI(bid, 0, 'full');

    var playBtn = el('hpctv-playbtn-' + bid);
    if (playBtn) {
      playBtn.addEventListener('click', function () {
        startVideo(bid, state[bid].currentIndex, 'full');
      });
    }

    var upNextChip = el('hpctv-upnext-' + bid);
    if (upNextChip) {
      upNextChip.addEventListener('click', function () {
        var next = state[bid].currentIndex + 1;
        if (next < getClips(bid).length) playClipFull(bid, next);
      });
    }

    var videoEl = el('hpctv-video-' + bid);
    if (videoEl) {
      videoEl.addEventListener('timeupdate', function () {
        if (!this.duration) return;
        var bar = el('hpctv-vprog-' + bid);
        if (bar) bar.style.width = ((this.currentTime / this.duration) * 100) + '%';
      });

      videoEl.addEventListener('ended', function () {
        var next = state[bid].currentIndex + 1;
        if (next < getClips(bid).length) {
          playClipFull(bid, next);
        } else {
          resetToIdle(bid, 'full');
        }
      });

      videoEl.addEventListener('play', function () {
        var pw = this.closest('.hpctv__player-wrap');
        if (pw) pw.classList.add('is-playing');
      });
      videoEl.addEventListener('pause', function () {
        var pw = this.closest('.hpctv__player-wrap');
        if (pw) pw.classList.remove('is-playing');
      });
    }
  }

  /* ============================================================
     UPDATE PLAYER UI (idle state)
  ============================================================ */
  function updatePlayerUI(bid, index, mode) {
    var clips  = getClips(bid);
    var clip   = clips[index];
    var total  = clips.length;
    var prefix = mode === 'single' ? 'hpctv-single-' : 'hpctv-';

    var titleEl = el(prefix + 'vtitle-' + bid);
    var metaEl  = el(prefix + 'vmeta-' + bid);
    if (titleEl) titleEl.innerHTML = clip.title + (clip.cc ? '<span class="hpctv__cc-badge">CC</span>' : '');
    if (metaEl)  metaEl.textContent = (index + 1) + ' of ' + total + ' · ' + clip.duration;

    var isMobile  = window.innerWidth <= 700;
    var isPortrait = isMobile && !!clip.portrait_url;
    var videoEl   = el(prefix + 'video-' + bid);
    if (videoEl) {
      var playerWrap = videoEl.closest('.hpctv__player-wrap');
      if (playerWrap) playerWrap.classList.toggle('is-portrait', isPortrait);
    }

    if (mode === 'full') {
      var upNext  = el('hpctv-upnext-' + bid);
      var upTitle = el('hpctv-upnext-title-' + bid);
      var upThumb = el('hpctv-upnext-thumb-' + bid);
      var next    = clips[index + 1];
      if (upNext) upNext.style.display = next ? '' : 'none';
      if (upTitle && next) upTitle.textContent = next.title;
      if (upThumb && next) upThumb.src = getPoster(bid);

      var items = document.querySelectorAll('#hpctv-pitems-' + bid + ' .hpctv__pl-item');
      items.forEach(function (item, i) {
        item.classList.toggle('is-active', i === index);
        var dot = item.querySelector('.hpctv__pl-dot');
        if (dot) {
          dot.className = 'hpctv__pl-dot' +
            (i < index ? ' hpctv__pl-dot--done' : i === index ? ' hpctv__pl-dot--now' : '');
        }
      });
    }

    var bar = el(prefix + 'vprog-' + bid);
    if (bar) bar.style.width = '0%';
  }

  /* ============================================================
     START VIDEO PLAYING
  ============================================================ */
  function startVideo(bid, index, mode) {
    var clips  = getClips(bid);
    var clip   = clips[index];
    var prefix = mode === 'single' ? 'hpctv-single-' : 'hpctv-';

    var videoEl = el(prefix + 'video-' + bid);
    var poster  = el(prefix + 'poster-' + bid);
    var mask    = el(prefix + 'mask-' + bid);
    var playBtn = el(prefix + 'playbtn-' + bid);
    if (!videoEl) return;

    var isMobile   = window.innerWidth <= 700;
    var isPortrait = isMobile && !!clip.portrait_url;
    var isMobLand  = isMobile && !isPortrait;
    var videoUrl   = getVideoUrl(clip);
    setVideoSource(videoEl, videoUrl, getPoster(bid));

    var playerWrap = videoEl.closest('.hpctv__player-wrap');
    if (playerWrap) { playerWrap.classList.toggle('is-portrait', isPortrait); playerWrap.classList.add('is-playing'); }

    videoEl.classList.add('is-active');
    if (poster)  poster.style.display  = 'none';
    if (mask)    mask.style.display    = 'none';
    if (playBtn) playBtn.style.display = 'none';

    var infoEl   = el(prefix + 'vtitle-' + bid);
    var infoWrap = infoEl ? infoEl.closest('.hpctv__video-info') : null;
    if (isMobLand && infoWrap) {
      infoWrap.style.display = 'none';
      function restoreInfo() { infoWrap.style.display = ''; }
      videoEl.addEventListener('pause', restoreInfo, { once: true });
      videoEl.addEventListener('ended', restoreInfo, { once: true });
    }

    if (mode === 'single') {
      videoEl.addEventListener('timeupdate', function () {
        if (!this.duration) return;
        var bar = el('hpctv-single-vprog-' + bid);
        if (bar) bar.style.width = ((this.currentTime / this.duration) * 100) + '%';
      });
    }

    videoEl.play().catch(function () {});
    state[bid].currentIndex = index;
  }

  /* ============================================================
     RESET TO IDLE
  ============================================================ */
  function resetToIdle(bid, mode) {
    var prefix  = mode === 'single' ? 'hpctv-single-' : 'hpctv-';
    var videoEl = el(prefix + 'video-' + bid);
    var poster  = el(prefix + 'poster-' + bid);
    var mask    = el(prefix + 'mask-' + bid);
    var playBtn = el(prefix + 'playbtn-' + bid);
    if (videoEl) {
      videoEl.pause();
      videoEl.classList.remove('is-active');
      var playerWrap = videoEl.closest('.hpctv__player-wrap');
      if (playerWrap) { playerWrap.classList.remove('is-portrait'); playerWrap.classList.remove('is-playing'); }
    }
    if (poster)  poster.style.display  = '';
    if (mask)    mask.style.display    = '';
    if (playBtn) playBtn.style.display = '';
    var infoEl   = el(prefix + 'vtitle-' + bid);
    var infoWrap = infoEl ? infoEl.closest('.hpctv__video-info') : null;
    if (infoWrap) infoWrap.style.display = '';
  }

  /* ============================================================
     PLAY HELPERS
  ============================================================ */
  function playClipFull(bid, index) {
    state[bid].currentIndex = index;
    updatePlayerUI(bid, index, 'full');
    startVideo(bid, index, 'full');
    var items = document.querySelectorAll('#hpctv-pitems-' + bid + ' .hpctv__pl-item');
    if (items[index]) items[index].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
  }

  function playClipSingle(bid, index) {
    var clip      = getClips(bid)[index];
    var singleEl  = el('hpctv-single-' + bid);
    var clipsEl   = el('hpctv-clips-' + bid);
    if (clipsEl)  clipsEl.style.display  = 'none';
    if (singleEl) singleEl.style.display = 'block';

    var titleEl = el('hpctv-single-vtitle-' + bid);
    var metaEl  = el('hpctv-single-vmeta-' + bid);
    if (titleEl) titleEl.innerHTML = clip.title + (clip.cc ? '<span class="hpctv__cc-badge">CC</span>' : '');
    if (metaEl)  metaEl.textContent = (index + 1) + ' of ' + getClips(bid).length + ' · ' + clip.duration;

    var singlePlayBtn = el('hpctv-single-playbtn-' + bid);
    if (singlePlayBtn) singlePlayBtn.onclick = function () { startVideo(bid, index, 'single'); };

    resetToIdle(bid, 'single');
    var singleVideo = el('hpctv-single-video-' + bid);
    if (singleVideo) { singleVideo.src = ''; singleVideo.load(); }
  }

  /* ============================================================
     INIT ALL VIDEO PANELS
  ============================================================ */
  document.querySelectorAll('[data-hpctv-carrier]').forEach(function (panelEl) {
    var bid = panelEl.dataset.hpctPanel;
    var cid = panelEl.dataset.hpctvCarrier;
    if (!bid || !cid || !CARRIERS[cid]) return;
    panels[bid] = { carrierId: cid };
    state[bid]  = { currentIndex: 0, mode: 'full' };
    buildPlaylist(bid);
    buildClipsGrid(bid);
    initPlayer(bid);
  });

  /* ============================================================
     TOGGLE (full tutorial ↔ individual clips)
  ============================================================ */
  document.querySelectorAll('[data-hpctv-carrier] .hpctv__toggle').forEach(function (tog) {
    var panelEl = tog.closest('[data-hpctv-carrier]');
    var bid     = panelEl ? panelEl.dataset.hpctPanel : null;

    tog.querySelectorAll('.hpctv__toggle-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        tog.querySelectorAll('.hpctv__toggle-btn').forEach(function (b) { b.classList.remove('is-active'); });
        this.classList.add('is-active');
        if (!bid) return;

        var isClips   = this.dataset.mode === 'clips';
        state[bid].mode = isClips ? 'clips' : 'full';

        var fullEl   = el('hpctv-full-'   + bid);
        var clipsEl  = el('hpctv-clips-'  + bid);
        var singleEl = el('hpctv-single-' + bid);
        if (fullEl)   fullEl.style.display   = isClips ? 'none' : '';
        if (clipsEl)  clipsEl.style.display  = isClips ? '' : 'none';
        if (singleEl) singleEl.style.display = 'none';

        if (isClips) { resetToIdle(bid, 'full'); } else { resetToIdle(bid, 'single'); }
      });
    });
  });

  /* ============================================================
     BACK BUTTON (single clip → clips grid)
  ============================================================ */
  document.querySelectorAll('.hpctv__back-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var bid     = this.dataset.panel;
      var singleEl = el('hpctv-single-' + bid);
      var clipsEl  = el('hpctv-clips-'  + bid);
      resetToIdle(bid, 'single');
      if (singleEl) singleEl.style.display = 'none';
      if (clipsEl)  clipsEl.style.display  = '';
    });
  });

  /* ============================================================
     MANUAL ACCORDION (View button)
  ============================================================ */
  document.querySelectorAll('.hpctv__view-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var bodyEl = document.getElementById(this.dataset.id);
      if (!bodyEl) return;
      bodyEl.classList.toggle('is-open');
      this.textContent = bodyEl.classList.contains('is-open') ? 'Close' : 'View';
    });
  });

})();
